var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.431,
    height: 16.431,
    viewBox: "0 0 16.431 16.431",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "chart",
    d: "M14.591,0a1.774,1.774,0,0,1,1.3.535,1.778,1.778,0,0,1,.535,1.3V14.591a1.826,1.826,0,0,1-1.84,1.84H1.84a1.774,1.774,0,0,1-1.3-.535A1.778,1.778,0,0,1,0,14.591V1.84A1.774,1.774,0,0,1,.535.535,1.778,1.778,0,0,1,1.84,0ZM5.477,12.794V6.376H3.637v6.418h1.84Zm3.637,0V3.637h-1.8v9.157h1.8Zm3.68,0V9.114h-1.84v3.68Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChart);
export default __webpack_public_path__ + "static/media/chart.eb41431d625c72bfc18814a54b86d355.svg";
export { ForwardRef as ReactComponent };